import { useMemo } from "react";

import { ContactGenre, type Contact } from "@/lib/gql/__generated__/graphql";

import { Label } from "@/components/ui/label/label";

type Props = {
	contact: Contact;
};

export const HeaderInner = ({ contact: { title, contactGenre } }: Props) => {
	const contactGenreText = useMemo(() => {
		switch (contactGenre) {
			case ContactGenre.HostSettings:
				return "設定・操作方法に関するお問い合わせ";
			case ContactGenre.GuestReservation:
				return "既存予約に関するお問い合わせ";
			case ContactGenre.Others:
			default:
				return "その他のお問い合わせ";
		}
	}, [contactGenre]);

	return (
		<div className="space-y-4">
			<Label variant="black" size="lg" text={contactGenreText} />

			<div>
				<p>件名</p>
				<h4 className="text-lg font-semibold">{title}</h4>
			</div>
		</div>
	);
};
